import { render, staticRenderFns } from "./Markdown.vue?vue&type=template&id=4c786e9a&scoped=true&"
import script from "./Markdown.vue?vue&type=script&lang=js&"
export * from "./Markdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c786e9a",
  null
  
)

export default component.exports